import React from "react";
import { useTranslation } from "react-i18next";
import { Eye, Gauge, Trophy, Users } from "lucide-react";
import { WHY_IMAGE } from "../../lib/assets";

const PROMISE_ICONS = [Eye, Gauge, Trophy, Users];

export const WhyEquiSight = () => {
  const { t } = useTranslation();
  const promises = t("why.promises", { returnObjects: true }) || [];

  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-background py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-[2rem] border border-[hsl(var(--border))]">
              <img
                src={WHY_IMAGE}
                alt="EquiSight"
                className="h-[420px] w-full object-cover transition-transform duration-700 hover:scale-[1.04] sm:h-[560px]"
              />
            </div>
            <p className="mt-6 text-xs uppercase tracking-[0.22em] text-[hsl(var(--ink-soft))]">
              {t("why.imageCaption")}
            </p>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--sand-dark))]">
              {t("why.eyebrow")}
            </p>
            <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] text-[hsl(var(--ink))] text-balance sm:text-5xl lg:text-[3.6rem]">
              {t("why.title")}
            </h2>

            <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {promises.map((p, i) => {
                const Icon = PROMISE_ICONS[i] || Eye;
                return (
                  <div
                    key={p.title}
                    className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface-secondary))] p-6"
                  >
                    <span className="grid h-10 w-10 place-items-center rounded-full bg-[hsl(var(--forest))] text-[hsl(var(--background))]">
                      <Icon className="h-5 w-5" strokeWidth={1.5} />
                    </span>
                    <h3 className="mt-5 font-display text-2xl text-[hsl(var(--ink))]">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-sm text-[hsl(var(--ink-soft))]">
                      {p.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyEquiSight;
